import styled from "styled-components";
import { colors } from "../../../Theme";

export const StyledA = styled.a`
  text-decoration: none;
  color: ${colors.neutral[100]}
`